// Item 35 — one output-column name per dimension INSTANCE.
//
// The first instance of a field/governed key keeps its natural column name, so every saved
// dashboard (sort levels, conditional formats, per-column styles, pivot levels) keeps working.
// A SECOND instance of the same governed key with its own date-hierarchy level gets
// `<key>_<level>`, which is what makes two hierarchies on one date field independent.
export function dimOutNames(dims) {
  const used = new Set();
  return (dims || []).map((d) => {
    if (!d) return null;
    if (d.alias) { used.add(d.alias); return d.alias; }
    const part = d.date_part && d.date_part !== "none" ? d.date_part : null;
    const base = d.key || (part ? `${d.field}_${part}` : d.field);
    if (!base) return null;
    if (used.has(base) && part) {
      const k = `${d.key || d.field}_${part}`;
      used.add(k);
      return k;
    }
    used.add(base);
    return base;
  });
}

// Single-dimension helper for callers without the sibling list (first-instance naming).
export function dimOutName(d) {
  return dimOutNames([d])[0];
}
